import React from "react";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import SpinnerSmall from "./SpinnerSmall";

const Title = (props) => {
  return (
    <div>
      <i className={props.iconClass}></i>
      {props.title}
    </div>
  );
};

const ListComparisonHeader = ({
  dark,
  hideAction,
  csvLoading,
  fromFile,
  loadCsv,
  actionTitle,
  actionClass,
  filename,
  csvData,
  pdfLoading,
  printPdf,
  ...rest
}) => {
  return (
    <div className={`card-header d-flex justify-content-between align-items-center ${dark && "grey"}`}>
      {dark ? <h5 className="m-0">{Title(rest)}</h5> : <span>{Title(rest)}</span>}
      <div className="d-flex justify-content-center align-items-center">
        {hideAction ? null : csvLoading ? (
          <div className="d-flex btn btn-primary m-0 disabled">
            <div className="color-white mr-05">
              <span>Loading CSV</span>
            </div>
            <SpinnerSmall />
          </div>
        ) : fromFile ? (
          <div className="d-flex btn btn-primary m-0" onClick={loadCsv}>
            <div className="color-white mr-05">
              <span>{actionTitle}</span>
            </div>
          </div>
        ) : (
          <CSVLink className={actionClass} filename={filename} data={csvData}>
            {actionTitle}
          </CSVLink>
        )}

        {pdfLoading ? (
          <div className="d-flex btn btn-primary m-0 ml-1 disabled">
            <div className="color-white mr-05">
              <span>Loading PDF</span>
            </div>
            <SpinnerSmall />
          </div>
        ) : (
          <div className="btn btn-primary m-0 ml-1" onClick={printPdf}>
            <div className="color-white mr-05">
              <span>Export PDF</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ListComparisonHeader.propTypes = {
  dark: PropTypes.bool,
  hideAction: PropTypes.bool,
  csvLoading: PropTypes.bool,
  fromFile: PropTypes.bool,
  loadCsv: PropTypes.func,
  actionTitle: PropTypes.string,
  actionClass: PropTypes.string,
  filename: PropTypes.string,
  csvData: PropTypes.object,
  pdfLoading: PropTypes.bool,
  printPdf: PropTypes.func,
};

export default ListComparisonHeader;
